/** Validação de CPF e CNPJ pelos dígitos verificadores. */

export function apenasDigitos(valor: string): string {
  return valor.replace(/\D/g, '');
}

export function validarCPF(entrada: string): boolean {
  const cpf = apenasDigitos(entrada);
  if (cpf.length !== 11) return false;
  if (/^(\d)\1{10}$/.test(cpf)) return false;

  for (const [tamanho, posicao] of [
    [9, 9],
    [10, 10],
  ] as const) {
    let soma = 0;
    for (let i = 0; i < tamanho; i++) soma += Number(cpf[i]) * (tamanho + 1 - i);
    const resto = ((soma * 10) % 11) % 10;
    if (resto !== Number(cpf[posicao])) return false;
  }
  return true;
}

export function validarCNPJ(entrada: string): boolean {
  const cnpj = apenasDigitos(entrada);
  if (cnpj.length !== 14) return false;
  if (/^(\d)\1{13}$/.test(cnpj)) return false;

  const calcular = (tamanho: number): number => {
    const pesos =
      tamanho === 12
        ? [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
        : [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
    let soma = 0;
    for (let i = 0; i < tamanho; i++) soma += Number(cnpj[i]) * (pesos[i] as number);
    const resto = soma % 11;
    return resto < 2 ? 0 : 11 - resto;
  };

  return calcular(12) === Number(cnpj[12]) && calcular(13) === Number(cnpj[13]);
}

/** Aceita CPF (11 dígitos) ou CNPJ (14 dígitos), com ou sem máscara. */
export function validarDocumento(entrada: string): boolean {
  const digitos = apenasDigitos(entrada);
  if (digitos.length === 11) return validarCPF(digitos);
  if (digitos.length === 14) return validarCNPJ(digitos);
  return false;
}

export function formatarCPF(entrada: string): string {
  const d = apenasDigitos(entrada).padEnd(11, ' ').slice(0, 11);
  return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6, 9)}-${d.slice(9)}`.trim();
}

export function formatarCNPJ(entrada: string): string {
  const d = apenasDigitos(entrada).padEnd(14, ' ').slice(0, 14);
  return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5, 8)}/${d.slice(8, 12)}-${d.slice(12)}`.trim();
}

export function formatarDocumento(entrada: string): string {
  const digitos = apenasDigitos(entrada);
  if (digitos.length === 11) return formatarCPF(digitos);
  if (digitos.length === 14) return formatarCNPJ(digitos);
  return entrada;
}

/** Telefone brasileiro com DDD: 10 ou 11 dígitos. */
export function validarTelefone(entrada: string): boolean {
  const d = apenasDigitos(entrada);
  return d.length === 10 || d.length === 11;
}
